const requireContext = require.context('../pages', true, /content\/.*\.json$/);

export const Loader = () => {
    return 'loading...';
};

export const contentLoader = () => {
    // loads all .json files located in /content folders.

    const pages = requireContext.keys().flatMap((key) => {
        const fileContent = requireContext(key);
        const filename = key.split('/').pop().replace('.json', '');

        return Object.entries(fileContent).map(([locale, data]) => {
            // Only assign slug from filename if not already present
            const hasSlug = data?.slug && typeof data.slug === 'string' && data.slug.length > 0;
            return {
                locale,
                ...data,
                slug: hasSlug ? data.slug : `${filename}`,
            };
        });
    });

    return pages;
};
